import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function Footer() {
  const [modalOpen, setModalOpen] = useState<string | null>(null);
  const openModal = (type: string) => setModalOpen(type);
  const closeModal = () => setModalOpen(null);
  const currentYear = new Date().getFullYear();
  const {
    t
  } = useLanguage();
  return <footer className="bg-brand-navy py-12 border-t border-slate-800" data-id="element-68">
      <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-69">
        <div className="mb-8" data-id="element-70">
          <h3 className="font-heading font-bold text-2xl text-white tracking-widest uppercase" data-id="element-71">
            VOZ<span className="text-brand-amber" data-id="element-72">PRO</span>
          </h3>
          <p className="text-slate-400 text-sm mt-2" data-id="element-73">{t('footer', 'desc')}</p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm text-slate-400" data-id="element-74">
          <button onClick={() => openModal('terms')} className="hover:text-brand-amber transition-colors" data-id="element-75">
            {t('footer', 'terms')}
          </button>
          <button onClick={() => openModal('privacy')} className="hover:text-brand-amber transition-colors" data-id="element-76">
            {t('footer', 'privacy')}
          </button>
        </div>

        <p className="text-slate-600 text-xs" data-id="element-77">
          © {currentYear}
          {t('footer', 'copyright')}
        </p>
      </div>

      {/* Simple Modal */}
      {modalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={closeModal} data-id="element-78">
          <div className="bg-white border border-slate-200 p-8 rounded-xl max-w-md w-full relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-79">
            <button onClick={closeModal} className="absolute top-4 right-4 text-slate-400 hover:text-brand-navy" data-id="element-80">
              <X className="w-6 h-6" data-id="element-81" />
            </button>

            <h3 className="text-xl font-bold text-brand-navy mb-4 font-heading uppercase" data-id="element-82">
              {modalOpen === 'terms' && t('footer', 'terms')}
              {modalOpen === 'privacy' && t('footer', 'privacy')}
            </h3>

            <div className="text-slate-600 text-sm space-y-4" data-id="element-83">
              <p data-id="element-84">
                {t('footer', 'modalText')}
                {modalOpen === 'terms' ? t('footer', 'modalTerms') : t('footer', 'modalPrivacy')}
                .
              </p>
            </div>

            <button onClick={closeModal} className="mt-6 w-full bg-brand-blue hover:bg-brand-blue-light text-white py-2 rounded transition-colors" data-id="element-85">
              {t('footer', 'close')}
            </button>
          </div>
        </div>}
    </footer>;
}